import "../../i18n";
import { useTranslation } from "react-i18next";
import { View } from "../../Data/Constants";
import LocationImage from "../../Assets/images/Shutterstock/HappyCouple.jpeg"
import FinancingImage from "../../Assets/images/Shutterstock/Accountant.jpeg"
import MarketingImage from "../../Assets/images/LeVIVO/LeVIVO_Longueuil_2/05-07.jpeg"
import MaintenanceImage from "../../Assets/images/Shutterstock/MaintenanceWorker.jpeg"
import OptimizationImage from "../../Assets/images/Shutterstock/Financing.jpeg"
import SimpleTextSection from "../../Components/Text/SimpleTextSection/SimpleTextSection";
import useDetectView from "../../Components/Hook/useDetectView";
import './ManagementPage.scss'

import IntroSectionImage from '../../Assets/images/LeVIVO/LeVIVO_LaPrairie/03-02.jpeg'
import SingleLayerIntroSection from "../../Components/Text/ParallaxTitle/Simple/SimpleParallaxTitle";
import { AngledBackgroundSection } from "../../Components/Text/AngledBackgroundTextSection/New version/AngledBackgroundSection";

export default function Construction() {
    const { t } = useTranslation();
    const currentView = useDetectView();

    let containerHeight = "500"; // Default height

    switch (currentView) {
        case View.Mobile:
            containerHeight = "auto";
            break;
        case View.Tablet:
            // Set height for tablet view, if different from default
            containerHeight = "850";
            break;
        default:
            break;
    }

    return (
        <div>
            <SingleLayerIntroSection title={t("management.intro.title")} backgroundImage={IntroSectionImage} />

            <div className="management-section-container">
                <SimpleTextSection
                    title={t("management.services.rental.title")}
                    text={t("management.services.rental.text")}
                    isDark={false}
                    isTransparent={true}
                    height={containerHeight}
                    position="left"
                    image={LocationImage}
                    isRounded={currentView === View.Tablet || currentView === View.Desktop || currentView === View.LargeTablet ? true : false}
                    imagePosition="child"
                    imageFit="cover"
                    isImageRounded={true}
                    delayInSecond={0}
                    durationInSecond={2}
                    enableShadow={false} />
            </div>
            {
                // ITEM 2
            }
            <AngledBackgroundSection
                backgroundColor="#0f1a2c"
                pageColor="#ffffff"
                contentPaddingY={0}
                contentPaddingX={0}
                top={{ type: "wave", height: 75, waveFlipX: true }}
                bottom={{ type: "wave", height: 75, waveFlipX: true }}
            >
                <div className="management-section-container">
                    <SimpleTextSection
                        title={t("management.services.financing.title")}
                        text={t("management.services.financing.text")}
                        isDark={true}
                        isTransparent={false}
                        height={containerHeight}
                        position="right"
                        image={FinancingImage}
                        isRounded={currentView === View.Tablet || currentView === View.Desktop || currentView === View.LargeTablet ? true : false}
                        imagePosition="child"
                        imageFit="cover"
                        isImageRounded={true}
                        delayInSecond={0}
                        durationInSecond={2}
                        enableShadow={false} />
                </div>
            </AngledBackgroundSection>
            {
                // ITEM 3
            }
            <div className="management-section-container">
                <SimpleTextSection
                    title={t("management.services.marketing.title")}
                    text={t("management.services.marketing.text")}
                    isDark={false}
                    isTransparent={true}
                    position="left"
                    height={containerHeight}
                    image={MarketingImage}
                    isRounded={currentView === View.Tablet || currentView === View.Desktop || currentView === View.LargeTablet ? true : false}
                    imagePosition="child"
                    imageFit="cover"
                    isImageRounded={true}
                    delayInSecond={0}
                    durationInSecond={2}
                    enableShadow={false} />
            </div>
            {
                // ITEM 4 #f3f3f3
            }
            <AngledBackgroundSection
                backgroundColor="#f3f3f3"
                pageColor="#ffffff"
                contentPaddingY={0}
                contentPaddingX={0}
                top={{ type: "wave", height: 75, waveFlipX: true }}
                bottom={{ type: "wave", height: 75, waveFlipX: true }}
            >
                <div className="management-section-container">
                    <SimpleTextSection
                        title={t("management.services.maintenance.title")}
                        text={t("management.services.maintenance.text")}
                        isDark={true}
                        isTransparent={true}
                        position="right"
                        height={containerHeight}
                        image={MaintenanceImage}
                        isRounded={currentView === View.Tablet || currentView === View.Desktop || currentView === View.LargeTablet ? true : false}
                        imagePosition="child"
                        imageFit="cover"
                        isImageRounded={true}
                        delayInSecond={0}
                        durationInSecond={2}
                        enableShadow={false} />
                </div>
            </AngledBackgroundSection>
            {
                // ITEM 5
            }

            <div className="management-section-container">
                <SimpleTextSection
                    title={t("management.services.optimization.title")}
                    text={t("management.services.optimization.text")}
                    isDark={false}
                    isTransparent={true}
                    position="left"
                    height={containerHeight}
                    image={OptimizationImage}
                    isRounded={currentView === View.Tablet || currentView === View.Desktop || currentView === View.LargeTablet ? true : false}
                    imagePosition="child"
                    imageFit="cover"
                    isImageRounded={true}
                    delayInSecond={0}
                    durationInSecond={2}
                    enableShadow={false} />
            </div>
        </div>

    )
}

